import React, { useEffect } from "react";
import { Flex, Spinner, Text } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { SignUp, useAuth } from "../ClerkAuthentication/clerkReact";
import { sanitizeClientReturnTo } from "./clientFlowUtils";
import { getConfigValue } from "../../config/runtimeConfig";
import { appendRedirectUrl } from "../ClerkAuthentication/clerkRedirects";

const ClientClerkSignUpPage = () => {
  const { isSignedIn } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search);
  const fromState = location.state?.from;
  const fromPath = fromState
    ? `${fromState.pathname || ""}${fromState.search || ""}${fromState.hash || ""}`
    : "";
  const redirectTo = sanitizeClientReturnTo(fromPath || query.get("returnTo"), "/client/purchases?source=signup");

  const signUpUrl = getConfigValue(
    "REACT_APP_CLERK_SIGN_UP_URL",
    process.env.REACT_APP_CLERK_SIGN_UP_URL,
    "/sign-up"
  );
  const isHostedSignUp = /^https?:\/\//i.test(signUpUrl);

  useEffect(() => {
    if (!isSignedIn) return;
    navigate(redirectTo, { replace: true });
  }, [isSignedIn, navigate, redirectTo]);

  useEffect(() => {
    if (!isHostedSignUp) return;
    window.location.assign(appendRedirectUrl(signUpUrl, redirectTo));
  }, [isHostedSignUp, signUpUrl, redirectTo]);

  if (isHostedSignUp) {
    return (
      <Flex minH="100vh" align="center" justify="center" bg="gray.50" direction="column" gap={3}>
        <Spinner />
        <Text color="gray.600">Redirecting to client sign up...</Text>
      </Flex>
    );
  }

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.50">
      <SignUp
        routing="path"
        path="/client/sign-up"
        signInUrl="/client/login"
        forceRedirectUrl={redirectTo}
        fallbackRedirectUrl={redirectTo}
      />
    </Flex>
  );
};

export default ClientClerkSignUpPage;
